__turbopack_context__.v({
  "MC_AEM_Wrapper": "SxnO7W_MC_AEM_Wrapper",
  "MC_Bg_Inherit": "SxnO7W_MC_Bg_Inherit",
  "MC_Button": "SxnO7W_MC_Button",
  "MC_Carousel": "SxnO7W_MC_Carousel",
  "MC_CarouselD": "SxnO7W_MC_CarouselD",
  "MC_Carousel_header": "SxnO7W_MC_Carousel_header",
  "MC_Carousel_thumbs_slide": "SxnO7W_MC_Carousel_thumbs_slide",
  "MC_Carousel_thumbs_wrapper": "SxnO7W_MC_Carousel_thumbs_wrapper",
  "MC_Carousel_track": "SxnO7W_MC_Carousel_track",
  "MC_Carousel_track_slide": "SxnO7W_MC_Carousel_track_slide",
  "MC_Carousel_track_slide__active": "SxnO7W_MC_Carousel_track_slide__active",
  "MC_Carousel_track_slide_media": "SxnO7W_MC_Carousel_track_slide_media",
  "MC_Carousel_track_slide_media_img": "SxnO7W_MC_Carousel_track_slide_media_img",
  "MC_Carousel_track_wrapper": "SxnO7W_MC_Carousel_track_wrapper",
  "MC_Core_HeadingStyle": "SxnO7W_MC_Core_HeadingStyle",
  "MC_Heading_1": "SxnO7W_MC_Heading_1",
  "MC_Layout_Article": "SxnO7W_MC_Layout_Article",
  "MC_Link_Accent": "SxnO7W_MC_Link_Accent",
  "MC_Link_Style_RichText": "SxnO7W_MC_Link_Style_RichText",
  "MC_Theme_Core": "SxnO7W_MC_Theme_Core",
  "MC_Theme_Dungeons": "SxnO7W_MC_Theme_Dungeons",
  "MC_Theme_Legends": "SxnO7W_MC_Theme_Legends",
  "MC_Theme_Marketplace": "SxnO7W_MC_Theme_Marketplace",
  "MC_Theme_Realms": "SxnO7W_MC_Theme_Realms",
  "MC_Theme_Vanilla": "SxnO7W_MC_Theme_Vanilla",
  "MC_articleGridA": "SxnO7W_MC_articleGridA",
  "MC_articleGridA_sectionRef": "SxnO7W_MC_articleGridA_sectionRef",
  "MC_articleHeroA_header_container": "SxnO7W_MC_articleHeroA_header_container",
  "MC_articleHeroA_header_subheadline": "SxnO7W_MC_articleHeroA_header_subheadline",
  "actionBlock": "SxnO7W_actionBlock",
  "alignItemsCenter": "SxnO7W_alignItemsCenter",
  "btn": "SxnO7W_btn",
  "btnPrimary": "SxnO7W_btnPrimary",
  "c-copyright": "SxnO7W_c-copyright",
  "cCopyright": "SxnO7W_cCopyright",
  "cMobileControls": "SxnO7W_cMobileControls",
  "cMobileControls__icon": "SxnO7W_cMobileControls__icon",
  "childrenSpaced": "SxnO7W_childrenSpaced",
  "col12": "SxnO7W_col12",
  "col4": "SxnO7W_col4",
  "col6": "SxnO7W_col6",
  "colMd4": "SxnO7W_colMd4",
  "container": "SxnO7W_container",
  "containerFluid": "SxnO7W_containerFluid",
  "containerLg": "SxnO7W_containerLg",
  "containerMd": "SxnO7W_containerMd",
  "containerSm": "SxnO7W_containerSm",
  "containerXl": "SxnO7W_containerXl",
  "containerXxl": "SxnO7W_containerXxl",
  "contentGrid": "SxnO7W_contentGrid",
  "contentSection": "SxnO7W_contentSection",
  "contents": "SxnO7W_contents",
  "contentsWrapper": "SxnO7W_contentsWrapper",
  "counterWidget": "SxnO7W_counterWidget",
  "dBlock": "SxnO7W_dBlock",
  "dNone": "SxnO7W_dNone",
  "dashboardContainer": "SxnO7W_dashboardContainer",
  "dashboardHeader": "SxnO7W_dashboardHeader",
  "fadeIn": "SxnO7W_fadeIn",
  "flexNowrap": "SxnO7W_flexNowrap",
  "fullWidthSection": "SxnO7W_fullWidthSection",
  "fullWidthXs": "SxnO7W_fullWidthXs",
  "initHidden": "SxnO7W_initHidden",
  "justifyContentBetween": "SxnO7W_justifyContentBetween",
  "lContents__aside": "SxnO7W_lContents__aside",
  "lFooter": "SxnO7W_lFooter",
  "lHeader": "SxnO7W_lHeader",
  "lHeader__controls": "SxnO7W_lHeader__controls",
  "likeBadge": "SxnO7W_likeBadge",
  "listGroup": "SxnO7W_listGroup",
  "listGroupItem": "SxnO7W_listGroupItem",
  "mainTitle": "SxnO7W_mainTitle",
  "menu": "SxnO7W_menu",
  "offset1": "SxnO7W_offset1",
  "offset3": "SxnO7W_offset3",
  "pContact": "SxnO7W_pContact",
  "pContact__item": "SxnO7W_pContact__item",
  "pContact__list": "SxnO7W_pContact__list",
  "pContact__title": "SxnO7W_pContact__title",
  "pFooterNav": "SxnO7W_pFooterNav",
  "pFooterNav__item": "SxnO7W_pFooterNav__item",
  "pForBeginner": "SxnO7W_pForBeginner",
  "pForBeginner__item": "SxnO7W_pForBeginner__item",
  "pForBeginner__list": "SxnO7W_pForBeginner__list",
  "pForBeginner__title": "SxnO7W_pForBeginner__title",
  "pHotWiki__title": "SxnO7W_pHotWiki__title",
  "pLikedWiki__title": "SxnO7W_pLikedWiki__title",
  "pRecentWiki__title": "SxnO7W_pRecentWiki__title",
  "pSpNav": "SxnO7W_pSpNav",
  "pSpNav__btnClose": "SxnO7W_pSpNav__btnClose",
  "pSpNav__item": "SxnO7W_pSpNav__item",
  "pSpNav__list": "SxnO7W_pSpNav__list",
  "pSpNav__register": "SxnO7W_pSpNav__register",
  "pSpNav__title": "SxnO7W_pSpNav__title",
  "panel": "SxnO7W_panel",
  "panelBody": "SxnO7W_panelBody",
  "panelHeading": "SxnO7W_panelHeading",
  "panelSuccess": "SxnO7W_panelSuccess",
  "recentWikiList": "SxnO7W_recentWikiList",
  "recentWikiRow": "SxnO7W_recentWikiRow",
  "row": "SxnO7W_row",
  "updateTime": "SxnO7W_updateTime",
  "versionBadge": "SxnO7W_versionBadge",
  "wikiCardItem": "SxnO7W_wikiCardItem",
  "wikiCardList": "SxnO7W_wikiCardList",
});
